import { getTenant, getUserName } from '../helpers';
import {api, getUserId, isJSON} from '@iblai/ibl-web-react-common';

export function getCredentialsIssued(callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdcredapi.credentialsOrgsUsersAssertionsOverTimeRetrieve(...args),
    getTenant(),
    getUserName(),
    {}
  )((err, data, response) => (err, callback(data), response));
}

export function getCredentialsPerCourse(queryParam, callback) {
  /*api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdcredapi.credentialsOrgsUsersCourseCredentialsList(...args),
    getTenant(),
    getUserName(),
    {
      ...additionalData,
    }
  )((err, data, response) => (err, data, callback(response.body)));*/
  const param = new URLSearchParams(queryParam).toString()
  const url = process.env.REACT_APP_IBL_DM_URL + `/api/credentials/orgs/${getTenant()}/users/${getUserName()}/course-credentials/?${param}`
  fetch(url, {
    method: 'GET',
    //body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('axd_token'),
    },
  }).then((resp) => {
    resp.json().then(callback).catch(()=>callback({}));
  }).catch(()=>callback({}));
}
